import { render, staticRenderFns } from "./TestEdit.vue?vue&type=template&id=4f0bcb98&scoped=true&"
import script from "./TestEdit.vue?vue&type=script&lang=js&"
export * from "./TestEdit.vue?vue&type=script&lang=js&"
import style0 from "./TestEdit.vue?vue&type=style&index=0&id=4f0bcb98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0bcb98",
  null
  
)

export default component.exports